<template>
	<v-row align="center" justify="center">
		<v-col cols="12" sm="8" md="4">
			<v-card
				class="elevation-12"
				flat
				max-width="450px"
				dark
				color="blue-grey darken-2"
			>
				<div class="text-center">
					<v-sheet color="white" class="pt-5 pb-4">
						<img src="./../assets/img/logo.svg" alt="CETABA" height="150" />
					</v-sheet>
				</div>

				<v-card-text v-if="user.keepLogged === false" class="mb-2">
					<v-form ref="form">
						<v-text-field
							label="E-mail"
							name="email"
							prepend-icon="fal fa-at"
							type="text"
							v-model="form.email"
							placeholder="Digite seu E-mail"
							id="email"
							maxlength="150"
							:rules="[rules.required, rules.email]"
							v-on:keyup.enter="login()"
						>
						</v-text-field>
						<v-text-field
							label="Senha"
							name="password"
							prepend-icon="fal fa-lock-alt"
							:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
							:type="showPassword ? 'text' : 'password'"
							@click:append="showPassword = !showPassword"
							v-model="form.password"
							placeholder="Digite sua senha"
							id="password"
							:rules="[rules.required, rules.min2]"
							v-on:keyup.enter="login()"
						>
						</v-text-field>

						<v-row class="mt-4 pl-3 pr-3">
							<v-col cols="12" md="6" lg="6" class="pa-0">
								<v-checkbox
									v-model="form.keepLogged"
									label="Manter logado"
								></v-checkbox>
							</v-col>
							<v-col cols="12" md="6" lg="6" class="pa-0">
								<v-btn
									color="success"
									@click="login()"
									v-if="user.keepLogged === false"
									block
								>
									<v-icon left>fas fa-sign-in-alt</v-icon> Login
								</v-btn>
								<v-btn
									v-if="user.keepLogged === true"
									color="primary"
									:to="{ name: 'Home' }"
									block
									>Logado</v-btn
								>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<div>
					<v-row class="pl-3 pr-3">
						<v-col cols="12">
							<v-btn href="http://cetaba.org/" target="_blank" block outlined small>
								Ir para o site
							</v-btn>
						</v-col>
					</v-row>
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

import idb from '@/api/idb'

export default {
	data() {
		return {
			showPassword: false,
			form: {
				email: null,
				password: null,
				keepLogged: false,
			},
			temp: [],
		}
	},
	computed: {
		...mapState(['rules', 'XMLHttpRequest', 'authenticated', 'user']),
	},
	created() {
		this.ifKeepLogged()
	},

	methods: {
		ifKeepLogged() {
			setTimeout(() => {
				idb
					.viewObjects('user', null, null)
					.then((res) => {
						if (res.length > 0) {
							if (res[0].keepLogged === true) {
								// console.log('Keep logged')
								this.$store.dispatch('user', { value: res[0] })
								this.$store.dispatch('authenticated', { value: true })

								let formData = new FormData()
								formData.append('user_id', res[0].id)
								formData.append('authorization', res[0].token)
								let vd = this
								this.$axiosPost
									.post('keep_logged.php', formData, {})
									.then(function(response) {
										if (response.data.error === 0) {
											vd.redirect(vd.$route.query.redirect || '/')
										} else {
											vd.$store.dispatch('errorServer', {
												data: response.data,
												destino: vd.$route.path,
											})
										}
									})
									.catch(function(response) {
										console.log('ERRO!! ' + response)
									})
							} else {
								console.log('Sem autorização de logar')
							}
						}
					})
					.catch(function(error) {
						console.log(error.message)
					})
			}, 600)
		},
		redirect(destination) {
			this.$router.push(destination)
		},
		login() {
			if (this.$refs.form.validate()) {
				let formData = new FormData()
				formData.append('email', this.form.email)
				formData.append('password', this.form.password)

				let vd = this
				this.$axiosPost
					.post('login.php', formData)
					.then(function(response) {
						if (response.data['error'] === 0) {
							let userTemp = response.data['user']
							userTemp.keepLogged = vd.form.keepLogged
							userTemp.token = response.data['token']
              idb.addObject('user', userTemp)
							vd.$store.dispatch('logIn', {
								user: userTemp,
								authenticated: true,
							})

							vd.redirect(vd.$route.query.redirect || '/')
						} else {
							vd.$store.dispatch('errorServer', {
								data: response.data,
								destino: vd.$route.path,
							})
						}
					})
					.catch(function(response) {
						vd.$store.dispatch('XMLHttpRequest', { value: false })
						console.log('ERROR!! ' + response)
					})
			}
		},
	},
}
</script>

<style lang="css" scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
	border-radius: 6px;
}
.v-sheet {
	border-radius: 6px 6px 0 0;
}
.v-input--selection-controls {
    margin-top: 0px;
}
</style>
